module.exports = "https://img.zhijierongxing.com/saas/img/shop_item_bg.69abcbb5.png";